class NoAddressError extends Error {
  constructor(message) {
    super(message);
    this.name = 'NoAddressError';
  }
}

export default NoAddressError;
